import React from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';

const TelegramTriggerConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-3">
      <div>
        <label className={commonStyles.label}>
          Bot Token
        </label>
        <input
          type="password"
          value={node.data.config.botToken || ''}
          onChange={(e) => updateConfig('botToken', e.target.value)}
          className={commonStyles.input}
          placeholder="1234567890:ABCdefGHIjklMNOpqrsTUVwxyz"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Telegram BotFather-től kapott token
        </p>
      </div>
      
      <div>
        <label className={commonStyles.label}>
          Parancs
        </label>
        <input
          type="text"
          value={node.data.config.command || '/start'}
          onChange={(e) => updateConfig('command', e.target.value)}
          className={commonStyles.input}
          placeholder="/start"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          A parancs ami elindítja a flow-t (/ jellel kezdődik)
        </p>
      </div>

      <div>
        <label className={commonStyles.label}>
          Engedélyezett felhasználók
        </label>
        <input
          type="text"
          value={(node.data.config.allowedUsers || []).join(', ')}
          onChange={(e) => updateConfig('allowedUsers', e.target.value.split(',').map(s => s.trim()).filter(s => s))}
          className={commonStyles.input}
          placeholder="@username1, @username2"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Vesszővel elválasztott felhasználónevek (üresen hagyva mindenki használhatja)
        </p>
      </div>

      <div className="flex items-center">
        <input
          type="checkbox"
          id="requirePrivateChat"
          checked={node.data.config.requirePrivateChat || false}
          onChange={(e) => updateConfig('requirePrivateChat', e.target.checked)}
          className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
        />
        <label htmlFor="requirePrivateChat" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
          Csak privát chatben működjön
        </label>
      </div>

      <div className="flex items-center">
        <input
          type="checkbox"
          id="deleteCommand"
          checked={node.data.config.deleteCommand || false}
          onChange={(e) => updateConfig('deleteCommand', e.target.checked)}
          className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
        />
        <label htmlFor="deleteCommand" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
          Parancs üzenet törlése feldolgozás után
        </label>
      </div>
    </div>
  );
};

export default TelegramTriggerConfig;
